<nav class="top-tools-tab-mobile" aria-label="Writing Tools">
  <ul class="container d-flex">
    <li>
      <a
        [routerLink]="['/grammar-checker']"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [attr.aria-current]="router.url === '/grammar-checker' ? 'page' : null">

        <img
          src="assets/images/menu-icons/grammar-checker.svg"
          alt=""
          aria-hidden="true">

        <span>Grammar Checker</span>

        <span
          class="sr-only"
          *ngIf="router.url === '/grammar-checker'">
          Selected
        </span>
      </a>
    </li>

    <li>
      <a
        [routerLink]="['/ai-content-detector']"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [attr.aria-current]="router.url === '/ai-content-detector' ? 'page' : null">

        <img
          src="assets/images/menu-icons/ai-detector.svg"
          alt=""
          aria-hidden="true">

        <span>AI Detector</span>

        <span
          class="sr-only"
          *ngIf="router.url === '/ai-content-detector'">
          Selected
        </span>
      </a>
    </li>

    <li>
      <a
        [routerLink]="['/paraphrasing-tool']"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [attr.aria-current]="router.url === '/paraphrasing-tool' ? 'page' : null">

        <img
          src="assets/images/menu-icons/pharaphraser.svg"
          alt=""
          aria-hidden="true">

        <span>Paraphrasing Tool</span>

        <span
          class="sr-only"
          *ngIf="router.url === '/paraphrasing-tool'">
          Selected
        </span>
      </a>
    </li>

    <li>
      <a
        [routerLink]="['/journal-finder']"
        routerLinkActive="active"
        [attr.aria-current]="router.url.startsWith('/journal-finder') ? 'page' : null">

        <img
          src="assets/images/menu-icons/journal-finder.svg"
          alt=""
          aria-hidden="true">

        <span>Journal Finder</span>

        <span
          class="sr-only"
          *ngIf="router.url.startsWith('/journal-finder')">
          Selected
        </span>
      </a>
    </li>
  </ul>
</nav>